import React from 'react';
import YouTube from 'react-youtube';
import Box from '@mui/material/Box';
function Save({ widgetStyle, widgetProps }) {
    
    return (
        <Box sx={[widgetStyle ?? {}, { height: 1, width: 1, position: 'relative' }]}>
            <Box sx={{ position: 'absolute', top: 0, left: 0, width: 1, height: 1 }}></Box>
            <Box
                component={YouTube}
                title={'Youtube Video Player'}
                videoId={widgetProps.videoId ?? ''}
                sx={{ width: 1, height: 1, borderRadius: '20px', overflow: 'hidden' }}
                opts={{ height: '100%', width: '100%', playerVars: { playlist: widgetProps.videoId ?? '', loop: 1, autoplay: 1, controls: 0, mute: 1, enablejsapi: 1, disablekb: 1, origin: 'https://hyper-active.com/' } }}
            />
        </Box>
    )
}

export default React.memo(Save);